import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = ({ theme }) => `
  align-items: center;
  display: inline-flex;
  .fa {
    color: ${theme.colors.status.success};
    margin-right: ${px2rem(5)};
  }
`;

const themePropTypes = {
  colors: PropTypes.shape({
    status: PropTypes.shape({
      success: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'Wrapper',
  styled.div,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./components/ServiceProvidersList/SelectedLabel/Wrapper.js